import React from "react";
import "./CreateAccount.scss";
import PasswordStrengthBar from "react-password-strength-bar";
import { isValidEmail } from "../../UserManagement/AddNewUserModal/AddNewUserModal";
import ProfilePicUpload from "../../UserProfile/ProfilePicUpload/ProfilePicUpload";
import profilePic from "../../../assets/icons/header/profile_pic.png";
import { gql } from "@apollo/client";

import { apolloClient, uploadClient } from "../../../index";
import { notify } from "../../Notify/Notify";

export default class CreateAccount extends React.Component {
  state = {
    profilePic: profilePic,
    fullName: "",
    email: "",
    password: "",
    tncAccepted: false,
    scoreLevel: 0,
    isValidToken: true,
    isPasswordShown: false,
    validateLength: "",
    validateLowercase: "",
    validateUppercase: "",
    validateSpecialChar: "",
    passwordValidation: true,
  };

  hasValidValues = () => {
    return (
      this.state.password.length > 0 &&
      this.state.fullName.trim().length > 0 &&
      this.state.email.trim().length > 0 &&
      isValidEmail(this.state.email.trim()) &&
      this.state.tncAccepted && this.state.passwordValidation
    );
  };

  setProfilePicHandler = (img) => {
    this.setState({ profilePic: img });
  };

  getScoreClass = () => {
    const mapping = {
      0: "very-easy",
      1: "easy",
      2: "moderate",
      3: "good",
      4: "strong",
    };
    return mapping[this.state.scoreLevel];
  };

  dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);
    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  };

  loginHandler = (e) => {
    e.preventDefault();
    const [firstName, lastName] = this.state.fullName.split(" ");
    const variables = {
      firstName: firstName,
      lastName: lastName || "",
      password: this.state.password,
      token: this.props.match.params.token,
      profileImage:
        this.state.profilePic !== profilePic
          ? this.dataURItoBlob(this.state.profilePic)
          : null,
    };

    uploadClient
      .mutate({
        mutation: gql`
          mutation CreateUser(
            $token: String!
            $firstName: String!
            $lastName: String!
            $password: String!
            $profileImage: Upload
          ) {
            createUser(
              token: $token
              firstName: $firstName
              lastName: $lastName
              password: $password
              profileImage: $profileImage
            ) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.createUser.success) {
          this.props.history.push("/login");
          const detail = "Success";
          const title = "Account created succefully!";
          const type = "success";
          notify(detail, title, type);
        }
      })
      .catch((e) => {
        const detail = "Error";
        const title = lastName
          ? e.message
          : "Please enter the last name as well.";
        const type = "error";
        notify(detail, title, type);
      });
  };

  componentDidMount() {
    const variables = {
      token: this.props.match.params.token,
    };
    apolloClient
      .mutate({
        mutation: gql`
          mutation ValidateToken($token: String!) {
            validateToken(token: $token) {
              success
              email
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.validateToken.email) {
          this.setState({
            email: result.data.validateToken.email,
          });
        }
      })
      .catch((e) => {
        this.setState({ isValidToken: false });
      });
  }

  loginRedirect = (e) => {
    e.preventDefault();
    this.props.history.push("/login");
  };

  togglePasswordVisiblity = () => {
    const { isPasswordShown } = this.state;
    this.setState({ isPasswordShown: !isPasswordShown });
  };

  passwordValidator = (e) => {
    let validateUppercase = /[A-Z]/g;
    let validateLowercase = /[a-z]/g;
    let validateNumber = /[0-9]/g;
    let validateSpecialChar = /[!@#$%^&_]/g;
    let validPassword = true;

    if (e.target.value.length > 7) {
      this.setState(
        {
          validateLength: "success",
        },
        () => {}
      );
    } else {
      validPassword = false;
      this.setState(
        {
          validateLength: "fail",
        },
        () => {}
      );
    }

    if (validateLowercase.test(e.target.value)) {
      this.setState({
        validateLowercase: "success",
      });
    } else {
      validPassword = false;
      this.setState({
        validateLowercase: "fail",
      });
    }

    if (validateUppercase.test(e.target.value)) {
      this.setState({
        validateUppercase: "success",
      });
    } else {
      validPassword = false;
      this.setState({
        validateUppercase: "fail",
        passwordValidation: false,
      });
    }

    if (validateNumber.test(e.target.value)) {
      this.setState({
        validateNumber: "success",
      });
    } else {
      validPassword = false;
      this.setState({
        validateNumber: "fail",
        passwordValidation: false,
      });
    }

    if (validateSpecialChar.test(e.target.value)) {
      this.setState({
        validateSpecialChar: "success",
      });
    } else {
      validPassword = false;
      this.setState({
        validateSpecialChar: "fail",
        passwordValidation: false,
      });
    }

    this.setState({
      passwordValidation: validPassword,
    });
  };

  render() {
    const { isPasswordShown } = this.state;
    const bar_svg = (
      <svg width="13px" height="13px" style={{"marginBottom":"6px", "marginRight":"4px","color":"rgba(114, 113, 120,0.7)"}}>
          <g class="password-strength__icon-group" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"><line x1="-6" y1="8" x2="8" y2="8"></line></g>
      </svg>
    )
    const success_svg = (<svg width="13px" height="13px" viewBox="0 0 512.000000 512.000000" className="mb-1 mr-1">
                      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      fill="#008000" stroke="none">
                      <path d="M4869 5033 c-36 -17 -82 -55 -137 -112 -45 -47 -567 -671 -1158
                      -1386 -592 -715 -1082 -1301 -1088 -1302 -6 -1 -155 167 -331 374 -345 405
                      -385 449 -448 491 -196 132 -472 68 -600 -140 -80 -131 -74 -326 16 -457 17
                      -25 273 -328 570 -673 457 -533 547 -632 595 -661 90 -54 150 -70 251 -65 103
                      5 192 41 265 109 34 30 342 502 1140 1743 601 936 1101 1716 1111 1735 53 105
                      72 240 40 301 -39 75 -126 92 -226 43z"/>
                      </g>
                    </svg>)
    const failed_svg = (<svg width="13px" height="13px" viewBox="0 0 512.000000 512.000000" className="mb-1 mr-1">
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                        fill="#ff0000" stroke="none">
                        <path d="M780 4467 c-76 -24 -140 -120 -140 -208 1 -83 7 -90 828 -911 l787
                        -788 -787 -787 c-821 -822 -827 -829 -828 -912 -1 -121 100 -222 221 -221 83
                        1 90 7 911 828 l788 787 788 -787 c821 -821 828 -827 911 -828 121 -1 222 100
                        221 221 -1 83 -7 90 -828 912 l-787 787 787 788 c821 821 827 828 828 911 1
                        121 -100 222 -221 221 -83 -1 -90 -7 -911 -828 l-788 -787 -788 787 c-608 608
                        -797 792 -832 807 -49 22 -106 25 -160 8z"/>
                        </g>
                        </svg>)
    return this.state.isValidToken ? (
      <div className="reset-password-container">
        <h3 className="title">Create Account</h3>

        <form>
          <div className="form-groups">
            <div className="profile-pic-holder">
              <ProfilePicUpload
                profilePic={this.state.profilePic}
                setProfilePicHandler={this.setProfilePicHandler}
              />
            </div>

            <div className="form-group">
              <label>Full Name*</label>
              <input
                type="text"
                maxLength="50"
                value={this.state.fullName}
                className="form-control"
                onChange={(e) => this.setState({ fullName: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Email Address*</label>
              <input
                type="email"
                maxLength="50"
                disabled
                value={this.state.email}
                className="form-control"
                placeholder="mark.g@gmail.com"
              />
            </div>

            <div className="form-group">
              <label>Password*</label>
              <input
                type={isPasswordShown ? "text" : "password"}
                maxLength="50"
                value={this.state.password}
                onChange={(e) => {
                  this.setState({ password: e.target.value })
                  this.passwordValidator(e)}
                }
                className="form-control password"
              />
              <i
                className={`fa ${isPasswordShown ? "fa-eye-slash" : "fa-eye"} password-icon`}
                onClick={this.togglePasswordVisiblity}
              />
              <PasswordStrengthBar
                password={this.state.password}
                scoreWords={[
                  "Very easy password",
                  "Easy password",
                  "Moderate password",
                  "Good password",
                  "Strong password",
                ]}
                shortScoreWord=""
                minLength={1}
                onChangeScore={(score) => this.setState({ scoreLevel: score })}
                className={`password-strength-bar ${this.getScoreClass()}`}
              />
              <div>
                <ul className="text-decoration-none password-validator mt-3 mb-0 pl-5">
                  <li className={this.state.validateLowercase}>
                     {this.state.validateLowercase === "success" ? success_svg : this.state.validateLowercase === "fail" ? failed_svg : bar_svg}                                    
                      At least one lowercase character</li>
                  <li className={this.state.validateUppercase}>
                      {this.state.validateUppercase === "success" ? success_svg : this.state.validateUppercase === "fail" ? failed_svg : bar_svg}                                    
                      At least one uppercase character</li>  
                  <li className={this.state.validateSpecialChar} style={{"width":"256px","overflow":"inherit"}}>
                      {this.state.validateSpecialChar === "success" ? success_svg : this.state.validateSpecialChar === "fail" ? failed_svg : bar_svg}                                    
                      At least one  special character (!, @, #, _ , $, %, ^, &)</li>
                  <li className={this.state.validateLength}>
                      {this.state.validateLength === "success" ? success_svg : this.state.validateLength === "fail" ? failed_svg : bar_svg}                                    
                      At least eight character</li>
                  <li className={this.state.validateNumber}>
                    {this.state.validateNumber === "success" ? success_svg : this.state.validateNumber === "fail" ? failed_svg : bar_svg}                                    
                    At least one number</li>
                         
                </ul>
              </div>
            </div>

            <div className="form-group terms-and-conditions">
              <input
                type="checkbox"
                id="tnc-agreement"
                checked={this.state.tncAccepted}
                onChange={(e) =>
                  this.setState({ tncAccepted: e.target.checked })
                }
              />
              <label htmlFor="tnc-agreement">
                By submitting this form, you confirm that you agree to our{" "}
                <a href="/docs/TiklerTermsofUse.pdf" target="_blank">
                  Terms of Service
                </a>{" "}
                and consent to the storing and processing of your personal data
                as described in our{" "}
                <a href="/docs/TiklerPrivacyPolicy.pdf" target="_blank">
                  Privacy Policy
                </a>
                .
              </label>
            </div>
          </div>

          <button
            className="btn-primary submit-button"
            type="submit"
            disabled={!this.hasValidValues()}
            onClick={this.loginHandler}
          >
            Submit
          </button>
        </form>
      </div>
    ) : (
      <>
        <h3 className="title">Thank you for choosing us!</h3>
        <p className="sign-up-note">
          <br />
          Please reach out to the Tikler team for signing up as the link has
          been expired.
          <br />
          <br />
          <p className="login-options">
            Already have an account?{" "}
            <span className="login" onClick={this.loginRedirect}>
              Login
            </span>
          </p>
        </p>
      </>
    );
  }
}
